import { Device } from '@/store/device/types';
import apiRequest from '@/utils/apiRequest';
import { RequestUserData } from '@/utils/apiRequest/types';
import { calmLogger } from '@/utils/calmLogger';
import { getDeviceDataFromUserAgentString } from '@/utils/device';

export const getDevice = async (
	userAgent: string | null | undefined,
	userData: RequestUserData,
): Promise<Device> => {
	const deviceBasic = {
		deviceId: userData?.deviceId || undefined,
		...getDeviceDataFromUserAgentString(userAgent),
	};
	if (!userAgent) {
		return deviceBasic;
	}

	try {
		const result = await apiRequest({
			endpoint: 'device',
			method: 'GET',
			userData,
		});
		const data = result?.data;
		const device = {
			...data,
			...deviceBasic,
		};

		return !data ? deviceBasic : device;
	} catch (err) {
		calmLogger.error('Error retrieving device via GET /device', {}, err);
		return deviceBasic;
	}
};
